import React, { useEffect } from "react";
import { ArrowRightCircle } from "../Icons/ArrowRightCircle";
import { Text11, Text12 } from "./styles";
import { useApp } from "../../contexts";
import { formatMoney } from "../../utils/hepler";
import { getCommissionByMonth } from "../../services/app";
import BarChartAffiliate from "./BarChartAffiliate";
import { useState } from "react";
import moment from "moment/moment";
export const CardAffiliate1 = ({ style, data }) => {
  const { T, language, convertToCurrency } = useApp();
  const [dataChart, setDataChart] = useState({
    dataLabel: [],
    dataCommission: [],
    dataLRefer: [],
  });

  useEffect(() => {
    getCommissionByMonth().then((response) => {
      const data = response?.data?.data?.result ?? [];
      const fourMonthFirt = data?.splice(0, 4);
      const dataLabel = [];
      const dataCommission = [];
      const dataLRefer = [];
      fourMonthFirt.forEach((item) => {
        const label = moment(item.month, 'YYYYMM').format("MMMM");
        dataLabel.push(label);
        dataLRefer.push(item?.frontline_buyers);
        let amount = item?.total_commission ? +item?.total_commission : 0;
        // if (amount && !isNaN(amount)) {
        //   amount = amount;
        // }
        dataCommission.push(amount);
      });
      setDataChart({
        dataLabel: dataLabel.reverse(),
        dataCommission: dataCommission.reverse(),
        dataLRefer: dataLRefer.reverse(),
      });
    });
  }, []);

  return (
    <div className="bg-[#25292E] rounded-xl h-full pt-[35px]" style={style}>
      <div className="pl-[20px] pr-[12px]">
        <div className="flex justify-between items-center">
          <div className="flex flex-col w-[48%]">
            <Text11>{T("Total Realized Commission")}</Text11>
            <Text12 className="mt-2">
              {formatMoney(data?.totalCommission ?? 0, 2)} SZT
            </Text12>
          </div>
          <div style={{ height: 64, width: 1, marginRight: '15px', background: "#fff" }}></div>
          <div className="flex flex-col  w-[48%]">
            <Text11>{T("Referral Buyers")}</Text11>
            <Text12 className="mt-2">
              {formatMoney(data?.frontline_buyers ?? 0, 0)}
            </Text12>
          </div>
          
        </div>
      </div>
      <div className="mt-3 pr-[12px] flex justify-around">
        {!!dataChart?.dataLabel?.length && (
          <BarChartAffiliate dataChart={dataChart} />
        )}

        {/* {data?.totalCommission ? (
          <>
            <ColumnChartAffiliate
              title={T("Direct Sale Commission")}
              height={data?.period_direct_sales_commission}
              color="#a5469a"
            />
            <ColumnChartAffiliate
              title={T("Team Affiliate Commission")}
              height={data?.period_binary_bonus}
              color="#7CB6FC"
            />
            <ColumnChartAffiliate
              title={T("My Team Affiliate Commission")}
              height={data?.period_my_team_commission}
              color="#B24B12"
            />
          </>
        ) : null} */}
      </div>
    </div>
  );
};
